export default __webpack_public_path__ + "5eeab832ebe15a44ba90256b0f6a9536.svg";